import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { AiChatState } from './ai-chat.reducers';

export const selectAiChatState = (state: AppState) => state.aiChat;

export const selectAiChatDrawerOpen = createSelector(
  selectAiChatState,
  (state: AiChatState) => state.drawerOpen
);

export const selectAiChatConversationList = createSelector(
  selectAiChatState,
  (state: AiChatState) => state.conversationList
);

export const selectActiveConversationId = createSelector(
  selectAiChatState,
  (state: AiChatState) => state.activeConversationId
);

export const selectActiveConversation = createSelector(
  selectAiChatState,
  (state: AiChatState) => state.activeConversation
);

export const selectIsDraft = createSelector(
  selectAiChatState,
  (state: AiChatState) => state.isDraft
);

export const selectSendMessageLoading = createSelector(
  selectAiChatState,
  (state: AiChatState) => state.loading.sendMessage
);

export const selectActiveConversationLoading = createSelector(
  selectAiChatState,
  (state: AiChatState) => state.loading.activeConversation
);

export const selectConversationListLoading = createSelector(
  selectAiChatState,
  (state: AiChatState) => state.loading.conversationList
);
